import { getQuanmaiApi, postQuanmaiApi } from './proxy'
export default class {
    //体验版-申请授权码
    applyTrialCode(data) {
        return postQuanmaiApi('/Activitys/applyTrialCode', data)
    }
    //用户绑定试用版申请码-会员权益
    bindTrialCode(data) {
        return postQuanmaiApi('/Orders/bindTrialCode', data)
    }
    //获取体验版到期提醒消息
    getTrialMsg() {
        return getQuanmaiApi('/Activitys/getTrialMsg',{})
    }
    //判断用户是否已申请过体验版
    checkUserTrial() {
        return getQuanmaiApi('/Activitys/checkUserTrial',{})
    }
}



// WEBPACK FOOTER //
// ./src/service/applyService.js